
// Import existing KeyboardHero types for seamless integration
// Note: In production integration, this would be: import { FingerType } from '@/types'
export type FingerType = 
  | 'leftThumb' | 'leftPointing' | 'leftMiddle' | 'leftRing' | 'leftPinky'
  | 'rightThumb' | 'rightPointing' | 'rightMiddle' | 'rightRing' | 'rightPinky';

// Left hand specific fingers that this picker handles
export type LeftHandFinger = 
  | 'leftPinky'
  | 'leftRing' 
  | 'leftMiddle'
  | 'leftPointing'
  | 'leftThumb';

// Right hand specific fingers that the right picker handles
export type RightHandFinger = 
  | 'rightPinky'
  | 'rightRing' 
  | 'rightMiddle'
  | 'rightPointing'
  | 'rightThumb';

// Hand parts for UI interaction (keeping enum for internal UI logic)
export enum HandPart {
  PINKY = 'leftPinky',
  RING = 'leftRing',
  MIDDLE = 'leftMiddle',
  INDEX = 'leftPointing', // Maps to leftPointing in KeyboardHero
  THUMB = 'leftThumb',
  PALM = 'PALM',
}

// Right hand parts for UI interaction
export enum RightHandPart {
  PINKY = 'rightPinky',
  RING = 'rightRing',
  MIDDLE = 'rightMiddle',
  INDEX = 'rightPointing', // Maps to rightPointing in KeyboardHero
  THUMB = 'rightThumb',
  PALM = 'PALM',
}

// All left hand fingers available in this picker
export const ALL_LEFT_FINGERS: LeftHandFinger[] = [
  'leftPinky',
  'leftRing',
  'leftMiddle',
  'leftPointing',
  'leftThumb',
];

// All right hand fingers available in the right picker
export const ALL_RIGHT_FINGERS: RightHandFinger[] = [
  'rightPinky',
  'rightRing',
  'rightMiddle',
  'rightPointing',
  'rightThumb',
];

// Helper to get finger display name (compatible with existing system)
export const getFingerDisplayName = (finger: LeftHandFinger | RightHandFinger): string => {
  switch (finger) {
    case 'leftThumb':
    case 'rightThumb':
      return 'Big';
    case 'leftPointing':
    case 'rightPointing':
      return 'Pointing';
    case 'leftMiddle':
    case 'rightMiddle':
      return 'Middle';
    case 'leftRing':
    case 'rightRing':
      return 'Ring';
    case 'leftPinky':
    case 'rightPinky':
      return 'Pinky';
    default:
      return 'Unknown';
  }
};

// Hand selection type for the app
export type HandSelection = 'left' | 'right' | 'both';
